/**
 * 전역적으로 선언돼있는 고유 변수를 통해 장비의 타입을 구분합니다.
 */
import { DEVICE_TYPE } from '../../../constants/commonConstants';
var getDeviceType = function () {
    var _a;
    // SSR에서 호출하는 경우 디바이스를 WEB이라고 판단
    if (typeof window === 'undefined') {
        return DEVICE_TYPE.WEB;
    }
    if (Object.prototype.hasOwnProperty.call(window, 'NFCommon')) {
        return DEVICE_TYPE.ANDROIDTV;
    }
    var webOSSystemInfo = (_a = window === null || window === void 0 ? void 0 : window.webOS) === null || _a === void 0 ? void 0 : _a.systemInfo();
    if ((webOSSystemInfo === null || webOSSystemInfo === void 0 ? void 0 : webOSSystemInfo.country) || (webOSSystemInfo === null || webOSSystemInfo === void 0 ? void 0 : webOSSystemInfo.smartServiceCountry) || (webOSSystemInfo === null || webOSSystemInfo === void 0 ? void 0 : webOSSystemInfo.timezone)) {
        return DEVICE_TYPE.WEBOS;
    }
    if (Object.prototype.hasOwnProperty.call(window, 'tizen')) {
        return DEVICE_TYPE.TIZEN;
    }
    return DEVICE_TYPE.WEB;
};
export default getDeviceType;
